import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Button } from "@dhis2/ui";
import InfoIcon from '@material-ui/icons/Info';
import _ from "lodash";
import Tooltip from "@material-ui/core/Tooltip";

const BasicTests = (props) => {
const basicTestData = Array.isArray(props?.basicTestData) ? props.basicTestData : [];
  
  const oBasicTests = {
    chart: {
        type: 'bar',
        backgroundColor: null,
        height:'320',
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['CREATININE', 'MICROALBUMINURIA', 'HBA1C', 'Blood Glucose(RANDOM)', 'Blood Glucose(FASTING)']
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        },
        labels: {
          enabled: false,
      },
    },
        credits: {
        enabled: false,
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent',
            dataLabels: {
                enabled: true
            }
        },
        showInLegend: true
    },
    series: [
    {
        name: 'Good control',
        color:"#ff779e",
        data: [
            {y:_.find(basicTestData,{indicatornames:"Good control-Creatinine"})?(_.find(basicTestData,{indicatornames:"Good control-Creatinine"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Good control-Microalbuminuria"})?(_.find(basicTestData,{indicatornames:"Good control-Microalbuminuria"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Good control-HbA1c"})?(_.find(basicTestData,{indicatornames:"Good control-HbA1c"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Good control-Random Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Good control-Random Blood Glucose"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Good control-Fast Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Good control-Fast Blood Glucose"}).counts):0, color:"#ff779e"}
        ]
    }, {
        name: 'Poor control',
        color:"#00acb1",
        data: [
            {y:_.find(basicTestData,{indicatornames:"Poor control-Creatinine"})?(_.find(basicTestData,{indicatornames:"Poor control-Creatinine"}).counts):0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Poor control-Microalbuminuria"})?(_.find(basicTestData,{indicatornames:"Poor control-Microalbuminuria"}).counts):0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Poor control-HbA1c"})?(_.find(basicTestData,{indicatornames:"Poor control-HbA1c"}).counts):-0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Poor control-Random Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Poor control-Random Blood Glucose"}).counts):0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Poor control-Fast Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Poor control-Fast Blood Glucose"}).counts):0, color:"#00acb1"}
        ]
    }, {
        name: 'Needs Attention',
        color:"#002060",
        data: [
            {y:_.find(basicTestData,{indicatornames:"Needs Attention-Creatinine"})?(_.find(basicTestData,{indicatornames:"Needs Attention-Creatinine"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Needs Attention-Microalbuminuria"})?(_.find(basicTestData,{indicatornames:"Needs Attention-Microalbuminuria"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Needs Attention-HbA1c"})?(_.find(basicTestData,{indicatornames:"Needs Attention-HbA1c"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Needs Attention-Random Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Needs Attention-Random Blood Glucose"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Needs Attention-Fast Blood Glucose"})?(_.find(basicTestData,{indicatornames:"Needs Attention-Fast Blood Glucose"}).counts):0, color:"#002060"}
        ]
    }]
  };

  return(
    <div>
            <div className="main-second-section mb-2">            
            <div className="heading">
                <h4 className="mt-0 mb-0"></h4>
            </div>   
            <div className="main-icon">
            <Tooltip title="Results of basic tests including fasting blood glucose, random blood glucose, HbA1C, microalbuminuria, and creatinine">
                <InfoIcon className="info-icon" />
            </Tooltip>
                {/* <Button variant="contained" className="blue-icon">%</Button>
                <Button variant="contained" className="gray-icon">#</Button> */}
            </div>                   
        </div>
        <HighchartsReact highcharts={Highcharts} options={oBasicTests} />
    </div>

);
};

export default BasicTests;